import { InteractionType } from "@/common/types";

export interface HistoryItemIconProps {
	size: IconSize;
	interactionType: InteractionType;
	isInbound: boolean;
	isMissed?: boolean;
	isParked?: boolean;
	isCallback?: boolean;
	isHighlighted?: boolean;
	hasUnreadIcon?: boolean;
	hideDirectionArrow?: boolean;
}

export enum IconSize {
	Small = 1,
	Medium = 2,
	Large = 3,
}
